export const STATUS_FORMATTER = {
  draft: 'Draft',
  need_approval: 'Need Approval',
  approved: 'Approved',
  rejected: 'Rejected',
  canceled: 'Canceled',
  cancelled: 'Cancelled',
  joined: 'Joined',
  waiting_approval: 'Waiting Approval',
};

const skpExternalDocFormatter = ({ log }) => {
  const fieldLabelMap = {
    signed_skp: 'Signed SKP',
    kwitansi: 'Kwitansi',
    faktur_pajak: 'Faktur Pajak',
    foto_bukti_tayang: 'Foto Bukti Tayang',
    foto_buku_rekening: 'Foto Buku Rekening',
    payment_proof: 'Payment Proof',
  };
  const fieldLabel =
    fieldLabelMap[log?.context?.item?.type] || log?.context?.item?.type;
  if (log.change_type === 'add') {
    return `[Documents: ${fieldLabel}] Added`;
  }
  if (log.change_type === 'remove') {
    return `[Documents: ${fieldLabel}] Removed`;
  }
  return `[Documents: ${fieldLabel}]: ${log.from_value} -> ${log.to_value}`;
};

const customerDocFormatter = ({ log }) => {
  const fieldLabelMap = {
    npwp: 'NPWP',
    sppkp: 'SPPKP',
    nib: 'NIB',
    akta_direksi_perusahaan: 'Akta Direksi Perusahaan',
    ktp: 'KTP',
    form_new_customer: 'Form New Customer',
    kartu_keluarga: 'Kartu Keluarga',
    surat_ketentuan_perdagangan: 'Surat Ketentuan Perdagangan',
    anggaran_dasar_perusahan: 'Anggaran Dasar Perusahaan',
    pengesahan_kemenhum_ham: 'Pengesahan Kementrian Hukum dan HAM',
    trading_terms: 'Agreement/Trading terms',
    erc: 'Enterprise Registration Certificate (ERC)',
    poa: 'Power of Attorney (PoA)',
    other_file: 'Other File',
  };
  const fieldLabel =
    fieldLabelMap[log?.context?.item?.type] || log?.context?.item?.type;
  if (log.change_type === 'add') {
    return `[Legal Documents: ${fieldLabel}] Added`;
  }
  if (log.change_type === 'remove') {
    return `[Legal Documents: ${fieldLabel}] Removed`;
  }
  return `[Legal Documents: ${fieldLabel}]: ${log.from_value} -> ${log.to_value}`;
};

const customerAddressFormatter = ({ log }) => {
  const addressTypeMap = {
    invoice_address: 'Invoice Address',
    delivery_address: 'Delivery Address',
    'invoice_address.name': 'Invoice Address Name',
    'invoice_address.state.name': 'Invoice Address State ID',
    'invoice_address.city.name': 'Invoice Address City ID',
    'invoice_address.district.name': 'Invoice Address District',
    'invoice_address.postal_code': 'Invoice Address ZIP Code',
    'invoice_address.street': 'Invoice Address Street',
    'invoice_address.street2': 'Invoice Address Street 2',
    'invoice_address.email': 'Invoice Address Email',
    'invoice_address.phone': 'Invoice Address Phone',
    'invoice_address.mobile': 'Invoice Address Mobile',
    'invoice_address.notes': 'Invoice Address Notes',
    'invoice_address.from_time': 'Invoice Address Schedule From Time',
    'invoice_address.to_time': 'Invoice Address Schedule To Time',
    'delivery_address.contact_person':
      'Delivery Address Person in Charge (PIC)',
    'delivery_address.name': 'Delivery Address Name',
    'delivery_address.state.name': 'Delivery Address State ID',
    'delivery_address.city.name': 'Delivery Address City ID',
    'delivery_address.district.name': 'Delivery Address District',
    'delivery_address.postal_code': 'Delivery Address ZIP Code',
    'delivery_address.street': 'Delivery Address Street',
    'delivery_address.street2': 'Delivery Address Street 2',
    'delivery_address.email': 'Delivery Address Email',
    'delivery_address.phone': 'Delivery Address Phone',
    'delivery_address.mobile': 'Delivery Address Mobile',
    'delivery_address.notes': 'Delivery Address Notes',
    'delivery_address.store_code': 'Delivery Address Store Code',
    'delivery_address.lat_long': 'Delivery Address Location',
    store_address: 'Store Address',
    'store_address.name': 'Store Address Name',
    'store_address.contact_person': 'Store Address Person in Charge (PIC)',
    'store_address.state.name': 'Store Address State ID',
    'store_address.city.name': 'Store Address City ID',
    'store_address.district.name': 'Store Address District',
    'store_address.country.name': 'Store Address Country',
    'store_address.postal_code': 'Store Address ZIP Code',
    'store_address.street': 'Store Address Street',
    'store_address.street2': 'Store Address Street 2',
    'store_address.email': 'Store Address Email',
    'store_address.phone': 'Store Address Phone',
    'store_address.mobile': 'Store Address Mobile',
    'store_address.notes': 'Store Address Notes',
    'store_address.store_code': 'Store Address Store Code',
    'store_address.lat_long': 'Store Address Location',
  };
  const name = log?.context?.item?.name || '';
  if (log.change_type === 'add') {
    return `[${addressTypeMap[log.field_name]}: ${name}] Added`;
  }
  if (log.change_type === 'remove') {
    return `[${addressTypeMap[log.field_name]}: ${name}] Removed`;
  }
  return `[${addressTypeMap[log.field_name]}: ${name}]: ${log.from_value} -> ${
    log.to_value
  }`;
};

const statusFormatter = ({ log }) => {
  const rejectedReason = log.context?.doc?.rejected_reason;
  const cancelledReason = log.context?.doc?.cancellation_info?.reason_cancelled;
  if (log.change_type === 'add') {
    return `[Status] Added`;
  }
  if (log.change_type === 'remove') {
    return `[Status] Removed`;
  }
  const fromValue = STATUS_FORMATTER[log.from_value] || log.from_value;
  const toValue = STATUS_FORMATTER[log.to_value] || log.to_value;
  let msg = `[Status]: ${fromValue} -> ${toValue}`;
  if (log.to_value === 'rejected' && rejectedReason) {
    msg += ` with reason ${rejectedReason}`;
  } else if (log.to_value === 'cancelled' && cancelledReason) {
    msg += ` with reason ${cancelledReason}`;
  }

  return msg;
};

export const LPB_LOG_FORMATTER = {
  update: {
    pick_up_date: 'Pick Up Date',
    lpb_number: 'GRN Number',
    shipping_date: 'Shipping Date',
    recieved_date: 'Received Date',
    notes: 'Notes',
    delivery_order_url: 'Delivery Order',
    performa_invoice: 'Proforma Invoice',
    others: 'Other File',
    goods_recieved: 'Goods Received',
    status: statusFormatter,
  },
};

export const SKP_EXTERNAL_LOG_FORMATTER = {
  create: function ({ params }) {
    if (params?.context?.doc?.brand?.name) {
      return [`[SKP External: ${params.context.doc.brand.name}] created`];
    }
    return [`[SKP External] created`];
  },
  delete: function ({ params }) {
    if (params?.context?.doc?.brand?.name) {
      return [`[SKP External: ${params.context.doc.brand.name}] deleted`];
    }
    return [`[SKP External] deleted`];
  },
  update: {
    skp_external_account_no: 'SKP External Account Number',
    kwitansi_no: 'Invoice / Kwitansi Number',
    reference_invoice_potong: 'Reference Invoice Potong',
    nilai_aktivitas: 'Nilai Aktivitas',
    grossup_pph: 'Grossup PPH',
    total_biaya: 'Total Biaya/DPP(coa exp)',
    pph: 'PPH(coa wht)',
    ppn: 'PPN(coa vat)',
    total_nett: 'Total Nett(coa ar)',
    notes: 'Notes',
    'customer.code': 'Customer',
    'skp_internal.reference_code': 'SKP Reference',
    documents: skpExternalDocFormatter,
    'documents.url': skpExternalDocFormatter,
    budget_sample: function ({ log }) {
      if (log.change_type === 'add') {
        return `[Budget Sample: ${log?.context?.doc?.brand?.name}] Added`;
      }
      if (log.change_type === 'remove') {
        return `[Budget Sample: ${log?.context?.doc?.brand?.name}] Removed`;
      }
      return `[Budget Sample: ${log?.context?.doc?.brand?.name}]: ${log.from_value} -> ${log.to_value}`;
    },
    dpp: function ({ log }) {
      if (log.change_type === 'add') {
        return `[DPP: ${log?.context?.doc?.brand?.name}] Added`;
      }
      if (log.change_type === 'remove') {
        return `[DPP: ${log?.context?.doc?.brand?.name}] Removed`;
      }
      return `[DPP: ${log?.context?.doc?.brand?.name}]: ${log.from_value} -> ${log.to_value}`;
    },
    'tax.tax_value': 'Tax (%)',
    'vat.tax_value': 'VAT (%)',

    status: statusFormatter,
  },
};

export const CUSTOMER_LOG_FORMATTER = {
  update: {
    image: 'Photo',
    name: 'Name',
    street: 'Street',
    street2: 'Street 2',
    'state.name': 'State ID',
    'city.name': 'City ID',
    'district.name': 'District',
    postal_code: 'ZIP Code',
    phone: 'Phone',
    mobile: 'Mobile',
    email: 'Email',
    owner_name: 'Person in Charge (PIC) Name',
    job_position: 'Job Title',
    notes: 'Notes',
    'sales_team.name': 'Sales Team',
    'market_type.code': 'Market Type',
    'market_type.business_type.code': 'Business Type',
    'market_type.business_type.account.code': 'Account',
    'user.name': 'Sales Person',
    'bank_account.name': 'Bank Name',
    'bank_account.branch': 'Branch',
    'bank_account.account_number': 'Account Number',
    'bank_account.owner_name': 'Account Name',
    special_expired_period: 'Special Expirate Date',
    'payment_terms.name': 'Payment Terms',
    limit_amount: 'Limit Amount',
    'cluster.name': 'Discount Regular',
    special_discount: 'Special Discount',
    customer_type: function ({ log }) {
      const getTypeName = (val) => {
        if (!val) {
          return '';
        }
        try {
          const parsed = typeof val === 'string' ? JSON.parse(val) : val;
          return parsed?.name || val;
        } catch {
          return val;
        }
      };
      if (log.change_type === 'add') {
        return `[Customer Type] Added`;
      }
      if (log.change_type === 'remove') {
        return `[Customer Type] Removed`;
      }
      const fromValue = getTypeName(log.from_value);
      const toValue = getTypeName(log.to_value);
      return `[Customer Type]: ${fromValue} -> ${toValue}`;
    },
    is_sub_distributor: 'Sub Distributor',
    is_active: 'Is Active',
    'signatures.prepared_by.url': 'Signature Prepared By',
    'signatures.acknowledge_by.url': 'Signature Acknowledged By',
    'signatures.customer_by.url': 'Signature Customer',
    'ktp_address.identification_number': 'KTP Identification Number',
    'ktp_address.name': 'KTP Name',
    'ktp_address.state.name': 'KTP State ID',
    'ktp_address.city.name': 'KTP City ID',
    'ktp_address.district.name': 'KTP District',
    'ktp_address.postal_code': 'KTP ZIP Code',
    'ktp_address.street': 'KTP Street',
    'ktp_address.street2': 'KTP Street 2',
    'vat_address.identification_number': 'NPWP Identification Number',
    'vat_address.name': 'NPWP Name',
    'vat_address.state.name': 'NPWP State ID',
    'vat_address.city.name': 'NPWP City ID',
    'vat_address.district.name': 'NPWP District',
    'vat_address.postal_code': 'NPWP ZIP Code',
    'vat_address.street': 'NPWP Street',
    'vat_address.street2': 'NPWP Street 2',
    invoice_address: customerAddressFormatter,
    'invoice_address.name': customerAddressFormatter,
    'invoice_address.state.name': customerAddressFormatter,
    'invoice_address.city.name': customerAddressFormatter,
    'invoice_address.district.name': customerAddressFormatter,
    'invoice_address.postal_code': customerAddressFormatter,
    'invoice_address.street': customerAddressFormatter,
    'invoice_address.street2': customerAddressFormatter,
    'invoice_address.email': customerAddressFormatter,
    'invoice_address.phone': customerAddressFormatter,
    'invoice_address.mobile': customerAddressFormatter,
    'invoice_address.notes': customerAddressFormatter,
    'invoice_address.from_time': customerAddressFormatter,
    'invoice_address.to_time': customerAddressFormatter,
    'invoice_address.list_day': function ({ log }) {
      const name = log?.context?.doc?.name || '';
      if (log.change_type === 'add') {
        return `[Invoice Address Schedule Day: ${name}] ${log.to_value} Added`;
      }
      if (log.change_type === 'remove') {
        return `[Invoice Address Schedule Day: ${name}] ${log.from_value} Removed`;
      }
      return `[Invoice Address Schedule Day]: ${log.from_value} -> ${log.to_value}`;
    },
    delivery_address: customerAddressFormatter,
    'delivery_address.name': customerAddressFormatter,
    'delivery_address.contact_person': customerAddressFormatter,
    'delivery_address.state.name': customerAddressFormatter,
    'delivery_address.city.name': customerAddressFormatter,
    'delivery_address.district.name': customerAddressFormatter,
    'delivery_address.postal_code': customerAddressFormatter,
    'delivery_address.street': customerAddressFormatter,
    'delivery_address.street2': customerAddressFormatter,
    'delivery_address.email': customerAddressFormatter,
    'delivery_address.phone': customerAddressFormatter,
    'delivery_address.mobile': customerAddressFormatter,
    'delivery_address.notes': customerAddressFormatter,
    'delivery_address.store_code': customerAddressFormatter,
    'delivery_address.lat_long': customerAddressFormatter,
    store_address: customerAddressFormatter,
    'store_address.name': customerAddressFormatter,
    'store_address.contact_person': customerAddressFormatter,
    'store_address.state.name': customerAddressFormatter,
    'store_address.city.name': customerAddressFormatter,
    'store_address.district.name': customerAddressFormatter,
    'store_address.country.name': customerAddressFormatter,
    'store_address.postal_code': customerAddressFormatter,
    'store_address.street': customerAddressFormatter,
    'store_address.street2': customerAddressFormatter,
    'store_address.email': customerAddressFormatter,
    'store_address.phone': customerAddressFormatter,
    'store_address.mobile': customerAddressFormatter,
    'store_address.notes': customerAddressFormatter,
    'store_address.store_code': customerAddressFormatter,
    'store_address.lat_long': customerAddressFormatter,
    documents: customerDocFormatter,
    beauty_advisor: function ({ log }) {
      if (log.change_type === 'add') {
        return `[Beauty Advisor: ${log.to_value}] Added`;
      }
      if (log.change_type === 'remove') {
        return `[Beauty Advisor: ${log.from_value}] Removed`;
      }
      return `[Beauty Advisor]: ${log.from_value} -> ${log.to_value}`;
    },
    merchandiser: function ({ log }) {
      if (log.change_type === 'add') {
        return `[Merchandiser: ${log.to_value}] Added`;
      }
      if (log.change_type === 'remove') {
        return `[Merchandiser: ${log.from_value}] Removed`;
      }
      return `[Merchandiser]: ${log.from_value} -> ${log.to_value}`;
    },
    key_account_manager: function ({ log }) {
      if (log.change_type === 'add') {
        return `[Key Account Manager: ${log.to_value}] Added`;
      }
      if (log.change_type === 'remove') {
        return `[Key Account Manager: ${log.from_value}] Removed`;
      }
      return `[Key Account Manager]: ${log.from_value} -> ${log.to_value}`;
    },
    account_manager: function ({ log }) {
      if (log.change_type === 'add') {
        return `[Account Manager: ${log.to_value}] Added`;
      }
      if (log.change_type === 'remove') {
        return `[Account Manager: ${log.from_value}] Removed`;
      }
      return `[Account Manager]: ${log.from_value} -> ${log.to_value}`;
    },
    payment_type: function ({ log }) {
      if (log.change_type === 'add') {
        return `[Payment Type] Added`;
      }
      if (log.change_type === 'remove') {
        return `[Payment Type] Removed`;
      }
      const paymentMap = {
        transfer: 'Transfer',
        giro: 'Giro/Cheque',
        tunai: 'Cash',
      };
      const fromValue = paymentMap[log.from_value] || '';
      const toValue = paymentMap[log.to_value] || '';
      return `[Payment Type]: ${fromValue} -> ${toValue}`;
    },
    is_pkp: function ({ log }) {
      if (log.change_type === 'add') {
        return `[Taxable Entrepreneur] Added`;
      }
      if (log.change_type === 'remove') {
        return `[Taxable Entrepreneur] Removed`;
      }
      const fromValue = log.from_value == 'true' ? 'Taxable' : 'Non Taxable';
      const toValue = log.to_value == 'true' ? 'Taxable' : 'Non Taxable';
      return `[Taxable Entrepreneur]: ${fromValue} -> ${toValue}`;
    },
    wht: function ({ log }) {
      if (log.change_type === 'add') {
        return `[WHT (Corporate/Personal)] Added`;
      }
      if (log.change_type === 'remove') {
        return `[WHT (Corporate/Personal)] Removed`;
      }
      const whtMap = {
        npwp_badan: 'Tax ID Corporate',
        npwp_pribadi: 'Tax ID Personal',
        non_npwp_badan: 'Non Tax ID Corporate',
        non_npwp_pribadi: 'Non Tax ID Personal',
      };
      const fromValue = whtMap[log.from_value] || '';
      const toValue = whtMap[log.to_value] || '';
      return `[WHT (Corporate/Personal)]: ${fromValue} -> ${toValue}`;
    },
    status: statusFormatter,
  },
};

export const SKP_INTERNAL_LOG_FORMATTER = {
  create: function ({ params }) {
    if (params?.context?.doc?.brand?.name) {
      return [`[SKP Internal: ${params.context.doc.brand.name}] created`];
    }
    return [`[SKP Internal] created`];
  },
  delete: function ({ params }) {
    if (params?.context?.doc?.brand?.name) {
      return [`[SKP Internal: ${params.context.doc.brand.name}] deleted`];
    }
    return [`[SKP Internal] deleted`];
  },
  update: {
    total_actual_budget: 'Total Actual Budget',
    status: statusFormatter,
    name: 'Name',
    description: 'Description',
    'coa_tax.coa_number': 'COA Tax Number',
    'coa_tax.tax_corporate.tax_value': 'Tax ID Corporate',
    'coa_tax.tax_personal.tax_value': 'Tax ID Personal',
    skp_type: 'Type',
    from_date: 'From Date',
    to_date: 'To Date',
    is_active: 'Is Active',
    total_estimate_budget: 'Total Estimate Budget',
    notes: 'Notes',
    budget_used: 'Budget Used',
    budget_remaining: 'Budget Remaining',
    'outlet.wht': function ({ log, params }) {
      return `[Outlet WHT: ${params?.context?.doc?.outlet?.name}]: ${log.from_value} -> ${log.to_value}`;
    },
    'outlet.is_pkp': function ({ log, params }) {
      return `[Outlet Taxable Entrepreneur: ${params?.context?.doc?.outlet?.name}]: ${log.from_value} -> ${log.to_value}`;
    },
    'customer.wht': function ({ log, params }) {
      return `[Customer WHT: ${params?.context?.doc?.customer?.name}]: ${log.from_value} -> ${log.to_value}`;
    },
    'customer.is_pkp': function ({ log, params }) {
      return `[Customer Taxable Entrepreneur: ${params?.context?.doc?.customer?.name}]: ${log.from_value} -> ${log.to_value}`;
    },
    dpp: function ({ log, params }) {
      if (log.change_type === 'add') {
        return `[DPP: ${params?.context?.doc?.brand?.name}] Added`;
      }
      if (log.change_type === 'remove') {
        return `[DPP: ${params?.context?.doc?.brand?.name}] Removed`;
      }
      return `[DPP: ${params?.context?.doc?.brand?.name}]: ${log.from_value} -> ${log.to_value}`;
    },
    skp_external: function ({ log, params }) {
      const name = params?.context?.doc?.reference_code || '';
      if (log.change_type === 'add') {
        return `[SKP External: ${name}] created`;
      }
      if (log.change_type === 'remove') {
        const reason = log.to_value ? ` (Reason: ${log.to_value})` : '';
        return `[SKP External: ${name}] deleted${reason}`;
      }
      return `[SKP External: ${name}]: ${log.from_value} -> ${log.to_value}`;
    },
    'skp_external.status': function ({ log, params }) {
      const name = params?.context?.doc?.reference_code || '';
      return `[SKP External: ${name}] [Status]: ${log.from_value} -> ${log.to_value}`;
    },
  },
};

export const REQUEST_PRODUCT_ELIGIBILITY_LOG_FORMATTER = {
  create: function ({ params }) {
    const label =
      params?.context?.doc?.customer?.name || params?.context?.doc?.name;
    if (label) {
      return [`[Product Listing: ${label}] created`];
    }
    return [`[Product Listing] created`];
  },
  delete: function ({ params }) {
    const label =
      params?.context?.doc?.customer?.name || params?.context?.doc?.name;
    if (label) {
      return [`[Product Listing: ${label}] deleted`];
    }
    return [`[Product Listing] deleted`];
  },
  update: {
    year: 'Year',
    'customer.name': 'Customer Name',
    'customer.code': 'Customer Code',
    is_active: function ({ log, params }) {
      const context = log?.context?.doc || params?.context?.doc;
      const key = context?.customer?.name
        ? 'Customer Active/Inactive'
        : 'Product Active/Inactive';
      const val = context?.customer?.name
        ? context.customer.name
        : context.name;
      if (log.change_type === 'add') {
        return `[${key}: ${val}] Added`;
      }
      if (log.change_type === 'remove') {
        return `[${key}: ${val}] Removed`;
      }
      return `[${key}: ${val}]: ${log.from_value} -> ${log.to_value}`;
    },
    name: 'Product Name',
  },
};

export const USER_LOG_FORMATTER = {
  update: {
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    image: 'Photo',
    'role.name': 'Role',
    'role.code': 'Role Code',
    is_active: 'Is Active',
    sales_code: 'Sales Code',
    salesman_type: 'Salesman Type',
    sales_team: 'Sales Team',
    branch: 'Branch',
    'carrier.name': 'Carrier',
  },
};

export const REQUEST_PRODUCT_TESTER_LOG_FORMATTER = {
  create: function ({ params }) {
    const name =
      params?.context?.doc?.name ||
      params?.context?.doc?.outlet?.name ||
      params?.context?.doc?.customer?.name;
    if (name) {
      return [`[Request Product Tester: ${name}] created`];
    }
    return [`[Request Product Tester] created`];
  },
  delete: function ({ params }) {
    const name =
      params?.context?.doc?.name ||
      params?.context?.doc?.outlet?.name ||
      params?.context?.doc?.customer?.name;
    if (name) {
      return [`[Request Product Tester: ${name}] deleted`];
    }
    return [`[Request Product Tester] deleted`];
  },
  update: {
    status: statusFormatter,
    'customer.name': 'Customer Name',
    'customer.code': 'Customer Code',
    'outlet.name': 'Outlet Name',
    'outlet.code': 'Outlet Code',
    'address.name': 'Address Name',
    'address.street': 'Address Street',
    'user.name': 'Requested By Name',
    shipping_date: 'Shipping Date',
    received_date: 'Received Date',
    attachments: 'Attachments',
    notes: 'notes',
    name: 'Product Name',
    is_received: 'Product Received',
  },
};
